const config = {
  reqMode: 'net',
  net: {
    host: process.env.REACT_APP_API_URL,
    host2: process.env.REACT_APP_API2_URL
  }
}

export default config